<template>
  <v-navigation-drawer
    class="h-100 pa-0 d-flex flex-column"
    fixed
    overlay-opacity="0.7"
    right
    style="z-index: 500"
    temporary
    width="520"
    :value="visible"
    @input="checkValue"
  >
    <div v-if="isLoading" class="h-100 d-flex align-center justify-center">
      <LoaderSpinner />
    </div>

    <div v-else class="h-100 ma-0 pa-0 d-flex flex-column">
      <div class="ribbon ma-0 px-2">
        <p class="overline ma-0 pa-0 text-uppercase teal--text text--darken-2">
          {{ $t('routines.template') }}
        </p>
      </div>
      <div
        class="d-flex justify-space-between align-center px-6"
        style="height: 56px;"
      >
        <p class="text-heading-6 font-bold mt-4 mb-3">
          {{ templateRoutine.name }}
        </p>
      </div>

      <v-divider> </v-divider>

      <div
        class="px-6"
        style="height: calc(100vh - 56px - 84px); overflow-y: scroll;"
      >
        <div v-if="templateRoutine.description" class="mt-4">
          <p class="grey--text text--darken-1 font-size-12 mb-1 pa-0">
            {{ $t('common.description') }}
          </p>
          <p class="body-2 blue-grey--text text--darken-3">
            {{ templateRoutine.description }}
          </p>
        </div>

        <div v-if="templateRoutine.frequency" class="mt-4">
          <p class="grey--text text--darken-1 font-size-12 mb-1 pa-0">
            {{ $t('routines.frequency_label') }}
          </p>

          <v-chip color="grey--text text--darken-1" outlined small>
            {{ $t(`routines.frequency.${templateRoutine.frequency}`) }}
          </v-chip>
        </div>

        <div v-if="templateRoutine.type" class="mt-4">
          <p class="grey--text text--darken-1 font-size-12 mb-1 pa-0">
            {{ $t('common.type') }}
          </p>
          <v-chip color="grey--text text--darken-1" outlined small>
            {{ $t(`routines.type.${templateRoutine.type}`) }}
          </v-chip>
        </div>

        <div class="mt-4">
          <p class="grey--text text--darken-1 font-size-12 mb-1 pa-0">
            {{ $t('common.roles.author') }}
          </p>
          <ChipAvatar
            link
            small
            outlined
            :account="templateRoutine.createdBy"
          />
        </div>

        <div v-if="hasChecklist" class="mt-4">
          <p class="subtitle-2 font-bold">
            {{ $t('checklist.checklist_one') }}
          </p>
          <ChecklistOverview :checklist="checklist" />
        </div>
      </div>

      <v-divider> </v-divider>

      <div class="d-flex align-center px-4" style="height: 84px;">
        <v-row class="ma-0 pa-">
          <v-col>
            <Button
              color="primary"
              :text="$t('common.button.continue')"
              @click="handleContinue"
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin'
import api from '@/api'
import _ from 'lodash'

import LoaderSpinner from '@/components/utils/LoaderSpinner.vue'
import Button from '@/components/UI/Button'
import ChipAvatar from '@/components/ChipAvatar.vue'
import ChecklistOverview from '@/components/Checklists/ChecklistOverview.vue'

export default {
  name: 'TemplateDrawer',

  mixins: [mixin, trackerMixin],

  components: {
    LoaderSpinner,
    Button,
    ChecklistOverview,
    ChipAvatar,
  },

  data() {
    return {
      isLoading: false,
      checklist: [],
    }
  },

  props: {
    visible: Boolean,
    templateRoutine: Object,
  },

  computed: {
    ...mapGetters(['organizationId']),

    hasChecklist() {
      return !_.isEmpty(this.checklist)
    },
  },

  async mounted() {
    this.fetchChecklist()
  },

  methods: {
    async fetchChecklist() {
      if (!this.templateRoutine?.checklist) return
      this.isLoading = true
      try {
        const { data: checklist } = await api.routine.getChecklistById(
          this.organizationId,
          this.templateRoutine.checklist
        )
        this.checklist = checklist
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isLoading = false
      }
    },

    checkValue(val) {
      if (!val) return this.$emit('close')
    },

    handleContinue() {
      this.trackRoutineViewNavigate({
        source: 'createRoutineModal',
        action: 'goToCreateScreen',
        fromTemplate: true,
      })
      this.navigateTo({
        name: 'createRoutineDefinition',
        params: {
          routineDefinitionId: this.templateRoutine.id,
          template: true,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.ribbon {
  min-width: 80px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: 11px;
  background-color: $color-teal-lighten2;

  &::before {
    content: '';
    display: block;
    left: -10px;
    position: absolute;
    border-right: 10px solid $color-teal-lighten2;
    border-top: 16px solid white;
    border-bottom: 16px solid white;
  }
}
</style>
